( function ($){

    $ (document).ready (function ($){
        var swiper = new Swiper ('.testimonial-slider-widget .swiper-container', {
            // Optional parameters
            loop: true,
            slidesPerView: 1,
            spaceBetween: 50,
            speed: 600,
            pagination: {
                el: '.testimonial-slider-widget .swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            autoplay: {
                delay: 3000,
            },

        });


        $ ('.testimonial-slider-widget .swiper-container').on ('mouseenter', function (e){
            swiper.autoplay.stop ()
        })
        $ ('.testimonial-slider-widget .swiper-container').on ('mouseleave', function (e){
            swiper.autoplay.start ()
        })

    });

} ) (jQuery);
